

import React, { useState, useEffect } from 'react';

const ChallengeSection: React.FC = () => {
  const [competitorCount, setCompetitorCount] = useState(247);

  useEffect(() => {
    const interval = setInterval(() => {
      setCompetitorCount(prev => prev + Math.floor(Math.random() * 3));
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 bg-gradient-to-br from-yellow-300 via-pink-400 to-purple-500 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-20 h-20 bg-white/20 rounded-full animate-pulse"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-white/15 rounded-full animate-bounce"></div>
        <div className="absolute bottom-20 left-1/4 w-24 h-24 bg-white/10 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-40 right-1/3 w-18 h-18 bg-white/20 rounded-full animate-bounce delay-500"></div>
      </div>

      {/* Floating Emojis */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-1/4 text-4xl animate-bounce">🔥</div>
        <div className="absolute top-40 right-1/4 text-3xl animate-pulse">💯</div>
        <div className="absolute bottom-32 left-1/3 text-5xl animate-bounce delay-700">⚡</div>
        <div className="absolute bottom-20 right-1/4 text-3xl animate-ping">🚀</div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          {/* Main Message */}
          <div className="mb-16">
            <div className="inline-block bg-white/20 backdrop-blur-sm rounded-full px-8 py-3 border border-white/30 mb-8">
              <span className="text-white font-black text-lg uppercase tracking-wide">🔥 HOW IT WORKS 🔥</span>
            </div>
            
            <h2 className="text-6xl lg:text-7xl font-black text-white mb-8 leading-tight">
              Lexi Reviews Every
              <span className="block text-transparent bg-gradient-to-r from-yellow-200 to-white bg-clip-text animate-pulse">
                Application Personally
              </span>
            </h2>
            
            <div className="bg-white/15 backdrop-blur-md rounded-3xl p-8 border border-white/30 max-w-5xl mx-auto">
              <p className="text-2xl lg:text-3xl text-white font-bold leading-relaxed mb-6">
                She's spent her twenties building an empire. 💼
              </p>
              <p className="text-2xl lg:text-3xl text-white font-bold leading-relaxed">
                Now she's ready to build something else. 💕
              </p>
              <div className="mt-8 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-2xl p-6 border-4 border-white">
                <p className="text-2xl text-black font-black">
                  Hundreds have applied. Lexi chooses who she wants to meet. Make your application count. 🎯
                </p>
              </div>
            </div>
          </div>

          {/* Application Stats */}
          <div className="relative mb-16">
            <div className="absolute -inset-4 bg-gradient-to-r from-red-500 via-yellow-500 to-pink-500 rounded-3xl blur-xl opacity-75 animate-pulse"></div>
            <div className="relative bg-white rounded-3xl p-12 border-8 border-gradient shadow-2xl">
              <div className="flex items-center justify-center space-x-4 mb-8">
                <div className="w-6 h-6 bg-red-500 rounded-full animate-pulse"></div>
                <span className="text-lg font-black text-gray-900 uppercase tracking-wide">📊 APPLICATION STATS</span>
                <div className="w-6 h-6 bg-red-500 rounded-full animate-pulse"></div>
              </div>
              
              <div className="text-8xl lg:text-9xl font-black text-transparent bg-gradient-to-r from-purple-600 via-pink-600 to-red-600 bg-clip-text mb-6 animate-pulse">
                {competitorCount.toLocaleString()}
              </div>
              
              <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl p-4 border-4 border-purple-300">
                <p className="text-2xl text-white font-black">
                  Men have applied to date Lexi 🔥
                </p>
              </div>
              
              <div className="mt-6 text-lg text-gray-700 font-bold">
                ⏰ Applications reviewed on a rolling basis
              </div>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gradient-to-br from-green-400 to-blue-500 rounded-3xl p-8 border-4 border-white shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <div className="text-6xl font-black text-white mb-4">✓</div>
              <div className="text-xl text-white font-bold">Lexi personally reviews each one 👑</div>
            </div>
            <div className="bg-gradient-to-br from-purple-400 to-pink-500 rounded-3xl p-8 border-4 border-white shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <div className="text-6xl font-black text-white mb-4">28-38</div>
              <div className="text-xl text-white font-bold">Age Range 🎯</div>
            </div>
            <div className="bg-gradient-to-br from-yellow-400 to-red-500 rounded-3xl p-8 border-4 border-white shadow-2xl transform hover:scale-105 transition-transform duration-300">
              <div className="text-6xl font-black text-white mb-4">100%</div>
              <div className="text-xl text-white font-bold">Serious Applicants Only 💯</div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="relative">
            <div className="absolute -inset-8 bg-gradient-to-r from-yellow-400 via-red-500 to-pink-500 rounded-3xl blur-2xl opacity-75 animate-pulse"></div>
            <div className="relative bg-white rounded-3xl p-12 border-8 border-gradient shadow-2xl">
              <div className="text-5xl mb-6">🚨</div>
              <h3 className="text-4xl lg:text-5xl font-black text-gray-900 mb-8 leading-tight">
                Ready to Make Your Case?
              </h3>
              
              <button 
                onClick={() => document.getElementById('application')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-16 py-6 rounded-2xl font-black text-2xl hover:from-purple-500 hover:to-pink-500 transition-all duration-300 transform hover:scale-110 shadow-2xl hover:shadow-purple-500/50 whitespace-nowrap border-4 border-white mb-6"
              >
                🔥 APPLY NOW 🔥
              </button>
              
              <div className="bg-gradient-to-r from-yellow-100 to-pink-100 rounded-2xl p-6 border-4 border-yellow-300">
                <p className="text-lg text-gray-800 font-bold">
                  ⚡ Lexi reviews every application. Quality over quantity. ⚡
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChallengeSection;
